<template>
    <div class="fullscreen" v-show="modals.fullscreen" :class="{mobile: isMobile}">
        <header :class="{mobile: isMobile}" class="fs">
            <div class="empty" v-show="isMobile"></div>
            <a :href="website" target="_blank" :class="{mobile: isMobile}">
                <img :src="logoComputed" :style="{height: logo.height}" :class="{hide: !logo.url}"/>
                <span :class="{hide: logo.url}"><span class="brand">{{
                        tokens.header.cfd
                    }}</span> {{ tokens.header.platform }}</span>
            </a>
            <div v-if="!moduleFtd" class="head" :class="{mobile: isMobile}">
                <button @click="close" class="fs-normal">{{ tokens.fullScreen.startTrading }}</button>
            </div>
        </header>

        <div class="menu" :class="{mobile: isMobile}">
            <HamburgerMenu/>
        </div>
        <div class="empty-aside menu" :class="{hide:!isMobile}">
            <HamburgerMenu/>
        </div>
        <main :class="{dashboard: modalFullscreen.page === 'dashboard'}" class="fs" ref="fullscreen">
            <Dashboard class="cabinet-item dashboard" v-if="modalFullscreen.page==='dashboard'"/>
            <!-- if to rebuild chart every time (fixes sizing) -->
            <Personal class="cabinet-item" v-show="modalFullscreen.page==='personal'"/>
            <Deposit class="cabinet-item" v-show="modalFullscreen.page==='deposit'"/>
            <Withdrawal class="cabinet-item" v-show="modalFullscreen.page==='withdrawal'"/>
            <Verification class="cabinet-item" v-show="modalFullscreen.page==='verification'"/>
            <Accounts class="cabinet-item" v-show="modalFullscreen.page==='accounts'"/>
            <Support :class="{mobile: isMobile}" class="cabinet-item support" v-show="modalFullscreen.page==='support'"/>
            <Savings class="cabinet-item" v-show="modalFullscreen.page==='savings'"/>
            <Settings class="cabinet-item" v-show="modalFullscreen.page==='settings'"/>
        </main>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {MODAL, MODAL_FULLSCREEN} from '@/store/mutations.type'
import {LOGO, WEBSITE, TRADINGVIEW_THEME, MODULE_FTD} from "@/common/config"
import {isMobile} from '@/common/helpers'

import HamburgerMenu from '@/components/Modals/HamburgerMenu'

import Dashboard from '@/components/FullscreenPages/Dashboard'
import Personal from '@/components/FullscreenPages/Personal'
import Deposit from '@/components/FullscreenPages/Deposit'
import Withdrawal from '@/components/FullscreenPages/Withdrawal'
import Verification from '@/components/FullscreenPages/Verification'
import Accounts from '@/components/FullscreenPages/Accounts'
import Support from '@/components/FullscreenPages/Support'
import Savings from '@/components/FullscreenPages/Savings'
import Settings from '@/components/FullscreenPages/Settings'
import {DEPOSITS_GET, DOCUMENTS_GET, LOGOUT, OTP_CREATE, WITHDRAWALS_GET} from "@/store/actions.type"
export default {
    name: 'Fullscreen',
    components: {
        Dashboard,
        Personal,
        Deposit,
        Withdrawal,
        Verification,
        Accounts,
        Support,
        Savings,
        Settings,
        HamburgerMenu
    },
    data() {
        return {
            isMobile: isMobile(),
            logo: LOGO,
            website: WEBSITE,
            tradingViewTheme: TRADINGVIEW_THEME,
            moduleFtd: MODULE_FTD
        }
    },
    methods: {
        close() {
            this.$store.commit(MODAL, {
                fullscreen: false
            })

            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })
        },
        changePage(page) {
            this.$store.commit(MODAL_FULLSCREEN, {
                page
            })
        },
        logout() {
            this.$store.dispatch(LOGOUT)
        },
    },
    computed: {
        ...mapGetters(['user', 'tokens', 'modals', 'modalFullscreen']),
        logoComputed() {
            return this.tradingViewTheme === 'Light' ? this.logo.url.replace(/white/, 'black') : this.logo.url
        }
    },
    watch: {
        modalFullscreen: {
            deep: true,
            handler(val) {
                switch (val.page) {
                    case 'deposit':
                        this.$store.dispatch(DEPOSITS_GET)
                        break
                    case 'withdrawal':
                        this.$store.dispatch(WITHDRAWALS_GET)
                        break
                    case 'verification':
                        this.$store.dispatch(DOCUMENTS_GET)
                        break
                    case 'settings':
                        if (!this.user.otp) {
                            this.$store.dispatch(OTP_CREATE)
                        }
                        break
                }
                this.$refs.fullscreen.scrollTo({ top: 0, behavior: 'smooth' })
            }
        }
    }
}
</script>

<style scoped>

.fullscreen {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    background: var(--background-dark);
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-template-rows: 76px 1fr;
    overflow-y: scroll;
    align-items: stretch;
    height: 100vh;
}


.fullscreen aside {
    position: static;
}

.support{
    height: 100%;
}

header {
    grid-column: 1/-1;
    border-bottom: 1px solid rgba(144, 189, 255, 0.3);
    background: var(--background-dark-mid);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 20;
    padding: 0 31px 0 32px;
}

header a {
    text-decoration: none;
}

header img {
    max-height: 50px;
    max-width: 200px;
}

header span {
    font-size: 24px;
    font-weight: 800;
}

.trading-btn {
    background: #2B834E;
    font-weight: 400;
    font-size: 18px;
}

.cabinet-item {
    padding: 2vw 10vw;
}

.dashboard {
    background-color: var(--background-dark);
}

main {
    overflow: scroll;
}

main.fs {
    background-color: var(--background-dark);
}

/* ================================ mobile */

header.mobile {
    position: fixed;
    width: 100%;
    height: auto;
}

.fullscreen.mobile header {
    padding: 3px 15px;
}

.fullscreen.mobile .cabinet-item {
    padding: 80px 20px;
}

.fullscreen.mobile {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    grid-auto-rows: auto;
}

.fullscreen.mobile > * {
    grid-column: 1/2;
}

.support.mobile .send {
    bottom: 5%;
}

.empty-aside {
    display: none;
}

.menu.mobile {
    position: fixed;
    height: 100%;
    background: rgba(30, 33, 58, 1);
    display: none;
    z-index: 10;
    padding-top: 60px;
}

.empty {
    width: 24px;
    height: 24px;
}

@media (min-width: 1000px) {
    .fullscreen {
        grid-template-rows: 4vw 1fr;
    }

    header.fs {
        padding: 0 1.5vw;
    }

    header.fs .trading-btn {
        padding: .7vw 2.7vw;
        font-size: 1.1vw;
        border-radius: .3vw;
        font-weight: 300;
    }

    header.fs img {
        max-width: 10vw;
        max-height: 2.6vw;
    }

    header.fs span {
        font-size: 1.3vw;
    }
}

@media (max-width: 1376px) {
    .cabinet-item {
        padding: 40px 30px;
    }
}

@media (max-width: 1000px) {

    header span {
        font-size: 16px;
    }
}

@media (max-width: 500px) {

    header img {
        max-height: 30px;
    }
}

</style>
